import { type FC } from "react";
import QuizPostContent from "~/components/PostContentComponent/Blocks/QuizPostContent";
import { type Poll } from "~/lib/db/poll";
import { type PostContentBlocksType } from "~/utils/postUtils";

type PollBlockProps = {
  block: PostContentBlocksType;
  polls: Poll[];
};

const PollBlock: FC<PollBlockProps> = ({ block, polls }) => {
  const idPoll = Number(block.innerHTML.match(/\d+/g));
  const getPollInfo = polls.find((poll) => poll.questionId == idPoll);
  return <QuizPostContent poll={getPollInfo} key={getPollInfo.questionId} />;
};
export default PollBlock;
